import { Policy } from 'policy-lib';
import { getGate } from '../../utils/getGates';
import { scopes } from '../../constants/scopes';
import { getScope } from '../../utils/getScopes';
export class EnrichmentPolicy extends Policy {
  accessBilling() {
    return this.user.hasScope(scopes.BILLING_ACCESS);
  }

  /**
   * Is a user-level role-based permission that allows a user to access
   * enrichment features.
   *
   * @returns {boolean}
   */
  accessEnrichment() {
    return this.user.hasScope(scopes.DATA_ENRICHMENT_ACCESS);
  }

  /**
   * Returns whether a user can access the enrichment platform pages and
   * features. This is parcel dependent and indicates whether the portal
   * has a breeze credits parcel.
   *
   * @returns {boolean}
   */
  accessPlatform() {
    return this.user.hasScope(scopes.ENRICHMENT_PLATFORM_ACCESS);
  }
  accessSmartProperties() {
    return this.user.hasGate(getGate('enrichmentSmartProperties'));
  }
  changeSettings() {
    return this.user.hasScope(getScope('manageDataEnrichment'));
  }
  free() {
    return this.user.hasScope(scopes.BREEZE_INTELLIGENCE_FREE);
  }
  get isLoaded() {
    return this.record.isLoaded;
  }
  enrichmentSettingAuto() {
    return this.record.settings.companyEnrichmentAuto && this.record.settings.contactEnrichmentAuto;
  }
  hubspotCredits() {
    return this.user.hasGate(getGate('hubspotCredits'));
  }

  /**
   * Returns whether a user can upgrade their account which requires
   * billing access.
   *
   * @returns {boolean}
   */
  upgrade() {
    return this.accessBilling();
  }
  viewUpgradeCTA() {
    return this.accessBilling();
  }
  viewAddonCTA() {
    return !this.accessEnrichment() && this.accessBilling() && !this.hubspotCredits();
  }
  viewAutoSettingsNudge() {
    return this.changeSettings() && !this.enrichmentSettingAuto();
  }
  viewCredits() {
    return this.accessEnrichment() || this.hubspotCredits();
  }
}